import _    from 'lodash';
import util from 'util/Util.js';
import eventBus from 'EventBus';
import constants from 'Constants';

class LeftPanelStateService {

    save(){
        this.scrollTop = $('#left-rail').scrollTop();
        this.expandedPages = $('div div.expanded-page');
        this.expandedElements =  $('li.object-selector a i.pf-carot-down');
        this.searchKeyword = $("#searchLeftPanel").val();        
        this.filterKeyword = $('#filtermenu').val();
        this.expandedFilterElements = $('#filterResults li a i.pf-carot-down');
        this.filterScrollTop = $('#filterResults').scrollTop();
        this.completeTree = $('#objects-tree').html();
    }

    saveFilterResult(){
        this.filterResult = $("#filterResults").html();
    }

    resetTree(){
        this.completeTree = '';
    }

    restorePages(id){
        const sanitized = util.sanitizeHTML(this.completeTree);
        $(id).html(sanitized);
    }

    savePages(){
        this.completeTree = $('#objects-tree').html();
    }

    restore(forced = false){

        this.restoreFilter(forced);

        window.setTimeout(() => {
            this.restorePosition();
        }, 500);
    }

    restoreFilter(forced = false){
        
        if(this.searchKeyword !== "" && !util.isEmpty(this.searchKeyword)){
            $('#searchLeftPanel').val(this.searchKeyword)
            eventBus.trigger(constants.EV_RESTORE_FILTER_RESULT);
        }
        
        if ((this.filterKeyword && this.filterKeyword !=='none' && $('#filtermenu').val() !== this.filterKeyword) || forced ){
            if (this.filterKeyword === 'none' && this.expandedFilterElements.length === 0) {
            } else {
                $('#filtermenu').val(this.filterKeyword);
                eventBus.trigger(constants.EV_RESTORE_FILTER_RESULT);
            }
        }
    }

    restorePosition() {
        $('#left-rail').scrollTop(this.scrollTop);
        $('#filterResults').scrollTop(this.filterScrollTop);
    }


}

export default new LeftPanelStateService;